import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-article-cmd-fourniss',
  templateUrl: './article-cmd-fourniss.component.html',
  styleUrls: ['./article-cmd-fourniss.component.scss']
})
export class ArticleCmdFournissComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
